import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MockPerson, MockTeam } from '../../team-action-mock.data';

export interface TeamMemberModalData {
  team: MockTeam;
  member: MockPerson;
}

// Maquette d'estimation « action d'équipe » : retrait d'un membre d'une équipe, impacts et confirmation.
@Component({
  selector: 'team-action-mock-team-member-removal-modal',
  templateUrl: './team-action-mock-team-member-removal-modal.component.html',
})
export class TeamActionMockTeamMemberRemovalModalComponent {
  /** Actions en attente de l'équipe, valeur fictive. */
  readonly pendingActions = 3;
  readonly remainingCount: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TeamMemberModalData,
    private dialogRef: MatDialogRef<TeamActionMockTeamMemberRemovalModalComponent>,
  ) {
    this.remainingCount = data.team.members.length - 1;
  }

  close(): void {
    this.dialogRef.close();
  }
}
